import { statusColor, statusLabel } from "@/lib/i18n";

export default function StatusBadge({ status, lang = "ar" }) {
  const cls = statusColor(status);
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold ${cls}`} data-testid={`status-badge-${status}`}>
      {statusLabel(status, lang)}
    </span>
  );
}
